const privacyPolicyContent = {
  title: "Privacy Policy",
  effectiveDate: "21 February 2026",
  sections: [
    {
      heading: "1. Information We Collect",
      content: `
Parimitra Pvt. Ltd. may collect personal information that you voluntarily provide through our website, particularly through our contact form. This information may include your name, email address, organisation name, project type, and any additional details you choose to include in your message or inquiry. Providing this information is entirely optional, and users may choose how much information they wish to share.

In addition to information you actively submit, we may collect limited non-personal information automatically when you visit our website. This may include browser type, device information, IP address, general geographic location, pages visited, and time spent on the website. Such data is collected in an aggregated and non-identifiable manner to help us understand website usage and improve user experience.
      `
    },
    {
      heading: "2. Purpose of Data Collection",
      content: `
The information we collect is used solely for legitimate business purposes. This includes responding to your inquiries, understanding your project requirements, communicating with you regarding potential services, and improving our offerings. Information helps us provide relevant responses, maintain internal records, and enhance the overall quality of our services.

We do not sell, rent, lease, or trade your personal information to third parties. Your information is used strictly for communication and operational purposes directly related to your inquiry or engagement with us.
      `
    },
    {
      heading: "3. Data Sharing",
      content: `
Personal information may be accessed by authorized team members within Parimitra Pvt. Ltd. strictly on a need-to-know basis for operational and communication purposes. We maintain internal controls to ensure that access to data is limited and appropriate.

We do not share personal information with third-party marketing agencies or external advertisers. Information may only be disclosed if required to comply with applicable laws, legal processes, regulatory obligations, or lawful government requests. In such cases, disclosure will be limited to what is legally required.
      `
    },
    {
      heading: "4. Data Security",
      content: `
We implement reasonable technical and organizational safeguards designed to protect personal information from unauthorized access, misuse, loss, alteration, or disclosure. These measures may include secure hosting environments, restricted access controls, and standard industry security practices.

While we strive to protect your information, no method of electronic transmission or storage is completely secure. Therefore, we cannot guarantee absolute security. Users are encouraged to exercise caution when sharing sensitive information online.
      `
    },
    {
      heading: "5. Data Retention",
      content: `
We retain personal information only for as long as it is necessary to fulfill the purpose for which it was collected. This includes responding to inquiries, maintaining communication records, and complying with any legal, regulatory, or contractual obligations.

Once information is no longer required, we take reasonable steps to delete, anonymize, or securely dispose of it in accordance with applicable standards and internal policies.
      `
    },
    {
      heading: "6. Cookies and Analytics",
      content: `
Our website may use basic cookies or analytics tools to understand website traffic, visitor behavior, and general usage patterns. Cookies are small data files stored on your device that help improve functionality and performance.

The analytics information collected is aggregated and does not directly identify individual users. This data is used solely to evaluate and improve website performance, user experience, and service offerings. Users may choose to disable cookies through their browser settings, though doing so may affect certain website functionalities.
      `
    },
    {
      heading: "7. User Rights",
      content: `
Users have the right to request access to the personal information they have submitted to us. They may also request correction of inaccurate information or deletion of their data, subject to applicable legal requirements. Requests related to personal data will be reviewed and processed within a reasonable timeframe.

We are committed to respecting user privacy rights and will take appropriate steps to verify identity before fulfilling such requests to ensure the security of personal information.
      `
    },
    {
      heading: "8. Contact",
      content: `
If you have any questions about this Privacy Policy, your personal information, or how your data is handled, you may contact Parimitra Pvt. Ltd. directly. We are committed to addressing concerns transparently and responsibly.

      `
    }
  ]
};

export default privacyPolicyContent;